import {makeExpandedLabelValues} from "../../helpers/make-expanded-label-values";
import {FunctionComponent} from "react";
import styles from './ChartLabelExpandedMobile.module.css';
import {AllowedColours} from "../../data/colours";

export interface ChartLabelExpandedMobileProps {
    val: number,
    oldVal: number,
    color: AllowedColours,
    width: number,
}

const ChartLabelExpandedMobile: FunctionComponent<ChartLabelExpandedMobileProps> = ({val, oldVal, color, width}) => {
    const {
        changeString,
        barWidthOld,
        barWidthNew,
        offsetOld,
        offsetNew,
        bgWidth,
    } = makeExpandedLabelValues(val, oldVal)

    return (<>
          <defs>
            <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
              <feOffset dx="5" dy="2"/>
              <feGaussianBlur result="blur" stdDeviation="3"/>
              <feFlood floodColor="#000" floodOpacity=".15"/>
              <feComposite in2="blur" operator="in"/>
              <feComposite in="SourceGraphic"/>
            </filter>
          </defs>
          <g className={styles.mobileLegendExpanded} style={{transform: `translateX(${width / 2 - bgWidth / 2}px)`}}>
            <g>
              <rect className={styles.legendSvgExpanded8} x="4.48" y="7.81" width={bgWidth} height="53.89" rx="16" ry="16"/>
              <g>
                <text className={styles.legendSvgExpanded2} transform={`translate(${offsetNew(110.09)} 29.85)`}><tspan x="0" y="0" fill={color}>{val}%</tspan></text>
                <text className={styles.legendSvgExpanded3} transform={`translate(${offsetNew(144.66)} 29.18)`}><tspan x="0" y="0" fill={color}>({changeString})</tspan></text>
                <text className={styles.legendSvgExpanded4} transform="translate(17.37 29.94)"><tspan x="0" y="0" fill={color}>2022</tspan></text>
                <rect className={styles.legendSvgExpanded1} x="56.97" y="20.93" width={barWidthNew} height="9" fill={color}/>
              </g>
              <g>
                <text className={styles.legendSvgExpanded6} transform={`translate(${offsetOld(97.1)} 49.84)`}><tspan x="0" y="0">{oldVal}%</tspan></text>
                <text className={styles.legendSvgExpanded7} transform="translate(17.37 49.92)"><tspan x="0" y="0">2021</tspan></text>
                <rect className={styles.legendSvgExpanded5} x="56.97" y="40.89" width={barWidthOld} height="9"/>
              </g>
            </g>
          </g>
        </>);
}

export default ChartLabelExpandedMobile;